import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const PMSCustomizationTemplateStore = GenericFieldFactory("PMS_CUSTOMIZATION_TEMPLATE");